import 'bootstrap/dist/css/bootstrap.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

const DEFAULT_TITLE = 'Den Udvidede Danske Ordbog';

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || DEFAULT_TITLE;
  next();
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
